import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { ScaleTrialBadge } from '@hotjar/recordings/src/features/RecordingsPage/components/Console/ScaleTrialBadge';

import type {
  SessionErrorsSegmentProps,
  SessionErrorsDataProps,
} from '../../../constants-types/SessionErrors';
import { SessionErrorsSegmentData } from './SupportViews/SessionErrorsSegmentData';
import { SmartPanelSegment } from '../SmartPanelBlocks';
import { SmartPanelSpacedTextWithBadge } from '../SmartPanelSpacedTextWithBadge';
import { SessionErrorsUpsell } from './SessionErrorsUpsell';

const StyledScaleTrialBadge = styled(ScaleTrialBadge)`
  margin-left: ${tokens.spacer.x2};
`;

const PanelSegment = styled(SmartPanelSegment)`
  border-bottom: ${tokens.spacer.x0pt5} solid ${tokens.color.ui_border_light};
  flex-direction: column;
`;

function SessionErrorsData({
  selectedDateRange,
  selectedTargetingValue,
  selectedDeviceType,
  searchPattern,
  selectedFiltersInUiFormat,
  currentSite,
}: SessionErrorsDataProps): JSX.Element {
  const { t } = useTranslation('heatmaps');
  const withScaleTrialBadge = currentSite.effectivePlan === 'business';

  return (
    <PanelSegment>
      <SmartPanelSpacedTextWithBadge
        text={t('smart-panel.session-errors.title')}
        icon="code_dev"
        badge={withScaleTrialBadge ? <StyledScaleTrialBadge /> : null}
      />
      <SessionErrorsSegmentData
        selectedDateRange={selectedDateRange}
        selectedTargetingValue={selectedTargetingValue}
        selectedDeviceType={selectedDeviceType}
        searchPattern={searchPattern}
        selectedFiltersInUiFormat={selectedFiltersInUiFormat}
        currentSite={currentSite}
      />
    </PanelSegment>
  );
}

export function SessionErrorsSegment({
  selectedDateRange,
  selectedTargetingValue,
  selectedDeviceType,
  searchPattern,
  currentSite,
  selectedFiltersInUiFormat,
  planAllowsErrorCapturing,
}: SessionErrorsSegmentProps): JSX.Element | null {
  if (!currentSite || !currentSite?.id) {
    return null;
  }

  if (!planAllowsErrorCapturing) {
    return <SessionErrorsUpsell currentSite={currentSite} />;
  }

  return (
    <SessionErrorsData
      selectedDateRange={selectedDateRange}
      selectedTargetingValue={selectedTargetingValue}
      selectedDeviceType={selectedDeviceType}
      searchPattern={searchPattern}
      selectedFiltersInUiFormat={selectedFiltersInUiFormat}
      currentSite={currentSite}
    />
  );
}
